(function () {
  function splitTitleSubChars(subEl) {
    if (!subEl || subEl.dataset.tnCcSplit === "1") return;
    var lines = subEl.innerHTML.split(/<br\s*\/?>/i);
    subEl.innerHTML = lines
      .map(function (line) {
        return Array.prototype.map
          .call(line, function (ch) {
            if (ch === " " || ch === "\n" || ch === "\r" || ch === "\t") {
              return '<span class="tn-customizetion-classics__title-char is-space"> </span>';
            }
            return (
              '<span class="tn-customizetion-classics__title-char">' +
              ch +
              "</span>"
            );
          })
          .join("");
      })
      .join("<br>");
    subEl.dataset.tnCcSplit = "1";
  }

  function finishTnCcIntro(root) {
    root.classList.remove("is-intro-pending");
    root.classList.add("is-intro-done");
    document.body.classList.remove("is-tn-cc-intro");
  }

  function playTnCcIntro(root, wrap, title) {
    if (!root || root._tnCcIntroPlayed) return;
    root._tnCcIntroPlayed = true;

    var brand = title && title.querySelector(".tn-customizetion-classics__title-brand");
    var sub = title && title.querySelector(".tn-customizetion-classics__title-sub");
    var headerEls = document.querySelectorAll(
      "body.template-page-tn-customizetion-classics .header__heading, body.template-page-tn-customizetion-classics .header__heading-link"
    );

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      finishTnCcIntro(root);
      gsap.set([wrap, brand, sub, headerEls], { opacity: 1, clearProps: "visibility" });
      return;
    }

    document.body.classList.add("is-tn-cc-intro");
    root.classList.add("is-intro-pending");
    splitTitleSubChars(sub);
    var chars = sub ? sub.querySelectorAll(".tn-customizetion-classics__title-char") : [];

    gsap.set(wrap, { opacity: 0 });
    if (brand) gsap.set(brand, { opacity: 0 });
    if (chars.length) gsap.set(chars, { opacity: 0 });
    if (sub) gsap.set(sub, { opacity: 1 });
    if (headerEls.length) gsap.set(headerEls, { opacity: 0, visibility: "hidden" });

    var tl = gsap.timeline({
      defaults: { ease: "power2.out" },
      onComplete: function () {
        finishTnCcIntro(root);
        if (headerEls.length) {
          gsap.set(headerEls, { clearProps: "opacity,visibility" });
        }
      },
    });

    // 1) 黒画面を少しキープ → 2) 動画ふわっと
    tl.to({}, { duration: 0.35 })
      .to(wrap, { opacity: 1, duration: 1.15 }, 0.35);

    // ヘッダーロゴも動画と同時に
    if (headerEls.length) {
      tl.to(
        headerEls,
        { opacity: 1, visibility: "visible", duration: 1.15 },
        0.35
      );
    }

    // 3) brand ふわっと
    if (brand) {
      tl.to(brand, { opacity: 1, duration: 0.9 }, "-=0.25");
    }

    // 4) sub を一文字ずつ
    if (chars.length) {
      tl.to(
        chars,
        {
          opacity: 1,
          duration: 0.28,
          stagger: 0.045,
          ease: "power1.out",
        },
        "-=0.1"
      );
    }

  }

  function initTnCcVideo() {
    var root = document.querySelector("[data-tn-cc]");
    if (!root) return;

    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      window.setTimeout(initTnCcVideo, 50);
      return;
    }

    if (root._tnCcMm) {
      root._tnCcMm.revert();
      root._tnCcMm = null;
    }

    gsap.registerPlugin(ScrollTrigger);

    var pin = root.querySelector("[data-tn-cc-pin]");
    var wrap = root.querySelector(".tn-customizetion-classics__video-wrap");
    var title = root.querySelector("[data-tn-cc-title]");
    var overlay = root.querySelector("[data-tn-cc-overlay]");
    var catchPanel = root.querySelector("[data-tn-cc-catch]");
    var stepsPanel = root.querySelector("[data-tn-cc-steps]");
    var whitePanel = root.querySelector("[data-tn-cc-white]");
    var overlayPanels = root.querySelectorAll("[data-overlay]");
    if (!pin || !wrap) return;

    var mm = gsap.matchMedia();
    root._tnCcMm = mm;

    mm.add(
      {
        isDesktop: "(min-width: 750px)",
        isMobile: "(max-width: 749px)",
      },
      function (context) {
        var isDesktop = context.conditions.isDesktop;
        var titleEndScale = 0.5;

        if (title) {
          gsap.set(title, {
            scale: 1,
            opacity: 1,
            visibility: "visible",
            transformOrigin: "top left",
          });
          title.classList.remove("is-top", "is-small", "is-corner");
        }
        var ctaEl = root.querySelector("[data-tn-cc-cta]");
        if (ctaEl) {
          gsap.set(ctaEl, { clearProps: "opacity,visibility" });
        }
        document.body.classList.remove(
          "is-tn-cc-steps",
          "is-tn-cc-hide-logo",
          "is-tn-cc-cta-filled",
          "is-tn-cc-cta-shown",
          "is-tn-cc-cta-on-white",
          "is-tn-cc-cta-hidden",
          "is-tn-cc-title-on-white",
          "is-tn-cc-white"
        );
        if (overlay) {
          gsap.set(overlay, { opacity: 0 });
        }

        // 画面表示時は CTA 非表示。少しスクロールしたら表示
        if (ctaEl) {
          ScrollTrigger.create({
            start: function () {
              return Math.round(window.innerHeight * 0.12);
            },
            invalidateOnRefresh: true,
            onEnter: function () {
              document.body.classList.add("is-tn-cc-cta-shown");
            },
            onLeaveBack: function () {
              document.body.classList.remove("is-tn-cc-cta-shown");
            },
          });
        }

        function elementPageTop(el) {
          var top = 0;
          var node = el;
          while (node) {
            top += node.offsetTop || 0;
            node = node.offsetParent;
          }
          return top;
        }

        // CUSTOMIZATION 行の中央（タイトル上端から）
        function customizationLineMidOffset() {
          if (!title) return 0;
          var sub = title.querySelector(".tn-customizetion-classics__title-sub");
          if (!sub) return 0;
          splitTitleSubChars(sub);
          var brand = title.querySelector(".tn-customizetion-classics__title-brand");
          var wasSmall = title.classList.contains("is-small");
          var brandTransition = brand ? brand.style.transition : "";
          var subTransition = sub.style.transition;
          if (wasSmall) {
            if (brand) brand.style.transition = "none";
            sub.style.transition = "none";
            title.classList.remove("is-small");
            void title.offsetHeight;
          }
          var br = sub.querySelector("br");
          var range = document.createRange();
          range.setStart(sub, 0);
          if (br) range.setEndBefore(br);
          else range.selectNodeContents(sub);
          var line = range.getBoundingClientRect();
          var titleRect = title.getBoundingClientRect();
          var scale = title.offsetHeight ? titleRect.height / title.offsetHeight : 1;
          if (!isFinite(scale) || scale <= 0) scale = 1;
          var offset = (line.top + line.height / 2 - titleRect.top) / scale;
          if (wasSmall) {
            title.classList.add("is-small");
            void title.offsetHeight;
            if (brand) brand.style.transition = brandTransition;
            sub.style.transition = subTransition;
          }
          return offset;
        }

        var frameRatio = 279 / 157;

        function mobileFrameHeight() {
          var bg = wrap.parentElement;
          var width = ((bg && bg.offsetWidth) || window.innerWidth) * 0.7154;
          return width / frameRatio;
        }

        // PC: 279:157 の横長。42% 枠を基本に、横幅は最低 580px
        function desktopFrameSize() {
          var bg = wrap.parentElement;
          var bgW = (bg && bg.offsetWidth) || window.innerWidth;
          var bgH = (bg && bg.offsetHeight) || window.innerHeight;
          var maxW = bgW * 0.42;
          var maxH = bgH * 0.42;
          var width = maxW;
          var height = width / frameRatio;
          if (height > maxH) {
            height = maxH;
            width = height * frameRatio;
          }
          if (width < 580) {
            width = 580;
            height = width / frameRatio;
          }
          return { width: width, height: height, bgH: bgH };
        }

        // 初期動画の上端。PC・SP とも横長の小枠を上下中央。
        // bg は sticky なので、吸着中の offsetTop はスクロール量になる。親のレイアウト位置を使う。
        function centeredVideoTop() {
          var bg = wrap.parentElement;
          var parentTop = bg && bg.parentElement ? elementPageTop(bg.parentElement) : 0;
          var bgH = (bg && bg.offsetHeight) || window.innerHeight;
          var frameH = isDesktop ? desktopFrameSize().height : mobileFrameHeight();
          return parentTop + (bgH - frameH) / 2;
        }

        // 動画は上下中央のまま、CUSTOMIZATION 行の中央を動画の上端に合わせる
        function syncTitleToVideo() {
          if (!title) return;
          var top = centeredVideoTop() - customizationLineMidOffset();
          var prev = title.style.transition;
          title.style.transition = "none";
          title.style.setProperty("--tn-cc-title-top", top + "px");
          void title.offsetHeight;
          title.style.transition = prev;
        }

        // ヒーロー: 動画が全面になる → 少しホールド → ピン解除後に catch へ
        var heroTl = gsap.timeline({
          scrollTrigger: {
            trigger: pin,
            start: "top top",
            end: "+=120%",
            scrub: true,
            pin: true,
            anticipatePin: 1,
            invalidateOnRefresh: true,
            onRefresh: syncTitleToVideo,
          },
        });

        if (isDesktop) {
          // 中心は画面中央に固定し、幅と高さだけ広げる
          heroTl.fromTo(
            wrap,
            {
              position: "absolute",
              top: "50%",
              left: "50%",
              xPercent: -50,
              yPercent: -50,
              width: function () {
                return desktopFrameSize().width;
              },
              height: function () {
                return desktopFrameSize().height;
              },
              scale: 1,
              transformOrigin: "center center",
            },
            {
              top: "50%",
              left: "50%",
              xPercent: -50,
              yPercent: -50,
              width: "100%",
              height: "100%",
              scale: 1,
              ease: "none",
              duration: 1,
              immediateRender: true,
            },
            0
          );
        } else {
          // SP: 279:157 のまま中心固定で拡大。終わりは高さいっぱい、横は画面外へはみ出す
          function mobileStartWidth() {
            var bg = wrap.parentElement;
            return ((bg && bg.offsetWidth) || window.innerWidth) * 0.7154;
          }
          function mobileCoverWidth() {
            var bg = wrap.parentElement;
            var bgH = (bg && bg.offsetHeight) || window.innerHeight;
            return bgH * frameRatio;
          }
          heroTl.fromTo(
            wrap,
            {
              position: "absolute",
              top: "50%",
              left: "50%",
              xPercent: -50,
              yPercent: -50,
              width: mobileStartWidth,
              height: function () {
                return mobileStartWidth() / frameRatio;
              },
              aspectRatio: "279 / 157",
              scale: 1,
              transformOrigin: "center center",
            },
            {
              top: "50%",
              left: "50%",
              xPercent: -50,
              yPercent: -50,
              width: mobileCoverWidth,
              height: function () {
                return mobileCoverWidth() / frameRatio;
              },
              aspectRatio: "279 / 157",
              scale: 1,
              ease: "none",
              duration: 1,
              immediateRender: true,
            },
            0
          );
        }

        // 2) 全面になってからタイトル縮小（PCのみ。SPはサイズ固定）
        if (title && isDesktop) {
          heroTl.to(
            title,
            {
              scale: titleEndScale,
              ease: "power1.out",
              duration: 0.35,
            },
            1
          );
        }

        if (overlay) {
          heroTl.to(
            overlay,
            {
              opacity: 0.2,
              ease: "none",
              duration: 0.35,
            },
            1
          );
        }

        // 3) 全面表示を長めにキープしてから catch へ
        heroTl.to({}, { duration: 1.8 });

        function setStepsUiDesktop(active) {
          document.body.classList.toggle("is-tn-cc-steps", active);
          if (title) {
            title.classList.toggle("is-corner", active);
          }
        }

        function setTitleTopSp(active) {
          document.body.classList.toggle("is-tn-cc-hide-logo", active);
          if (!title) return;
          title.classList.toggle("is-top", active);
        }

        function setTitleSmallSp(active) {
          if (!title) return;
          title.classList.toggle("is-small", active);
        }

        // catch / steps / info に入ったらオーバーレイを切り替え
        overlayPanels.forEach(function (panel) {
          var targetOpacity = parseFloat(panel.getAttribute("data-overlay") || "0.5");

          ScrollTrigger.create({
            trigger: panel.closest("[data-tn-cc-info-pin]") || panel,
            start: "top 55%",
            end: "bottom 45%",
            onEnter: function () {
              gsap.to(overlay, {
                opacity: targetOpacity,
                duration: 0.4,
                ease: "power1.out",
                overwrite: true,
              });
            },
            onEnterBack: function () {
              gsap.to(overlay, {
                opacity: targetOpacity,
                duration: 0.4,
                ease: "power1.out",
                overwrite: true,
              });
            },
          });
        });

        if (isDesktop) {
          // PC: steps 進入時にロゴを消してタイトルを左上へ
          if (stepsPanel) {
            ScrollTrigger.create({
              trigger: stepsPanel,
              start: "top 60%",
              onEnter: function () {
                setStepsUiDesktop(true);
              },
              onEnterBack: function () {
                setStepsUiDesktop(true);
              },
              onLeaveBack: function () {
                setStepsUiDesktop(false);
              },
            });
          }
        } else {
          // SP: トップから少しスクロールしたらタイトルを左上へ（サイズはそのまま）
          ScrollTrigger.create({
            start: function () {
              return Math.round(window.innerHeight * 0.18);
            },
            invalidateOnRefresh: true,
            onEnter: function () {
              setTitleTopSp(true);
            },
            onLeaveBack: function () {
              setTitleTopSp(false);
            },
          });

          // SP: catch の文字が画面に入ったらタイトルを縮小
          var catchText = catchPanel
            ? catchPanel.querySelector(".tn-customizetion-classics__catch")
            : null;
          if (catchText) {
            ScrollTrigger.create({
              trigger: catchText,
              start: "top bottom",
              onEnter: function () {
                setTitleSmallSp(true);
              },
              onEnterBack: function () {
                setTitleSmallSp(true);
              },
              onLeaveBack: function () {
                setTitleSmallSp(false);
              },
            });
          }

        }

        // 各 step: 自身の上端から約20%が見えたらふわっと表示
        // SP の info-item: 自身の上端から約40%が見えたらふわっと表示
        // 最初の info-item の表示に合わせて steps 全体はふわっと消す
        var stepsEl = root.querySelector(".tn-customizetion-classics__steps");
        var stepEls = root.querySelectorAll(".tn-customizetion-classics__step");
        var infoItemEls = root.querySelectorAll(".tn-customizetion-classics__info-item");

        function fadeSoft(el, show) {
          if (!el) return;
          gsap.to(el, {
            opacity: show ? 1 : 0,
            duration: 1,
            ease: "power2.out",
            overwrite: true,
          });
        }

        function bindReveal(el, onShow, onHide, revealRatio) {
          var ratio = revealRatio == null ? 0.2 : revealRatio;
          gsap.set(el, { opacity: 0 });
          ScrollTrigger.create({
            trigger: el,
            start: function () {
              var reveal = Math.round(el.offsetHeight * ratio);
              return "top bottom-=" + reveal;
            },
            invalidateOnRefresh: true,
            onEnter: function () {
              fadeSoft(el, true);
              if (onShow) onShow();
            },
            onLeaveBack: function () {
              fadeSoft(el, false);
              if (onHide) onHide();
            },
          });
        }

        var catchEl = root.querySelector(".tn-customizetion-classics__catch");
        stepEls.forEach(function (el, index) {
          var isFirst = index === 0;
          bindReveal(
            el,
            isFirst
              ? function () {
                  fadeSoft(catchEl, false);
                }
              : null,
            isFirst
              ? function () {
                  fadeSoft(catchEl, true);
                }
              : null
          );
        });

        infoItemEls.forEach(function (el, index) {
          var isFirst = index === 0;
          bindReveal(
            el,
            isFirst
              ? function () {
                  fadeSoft(stepsEl, false);
                }
              : null,
            isFirst
              ? function () {
                  fadeSoft(stepsEl, true);
                }
              : null,
            isDesktop ? 0.2 : 0.4
          );
        });

        // catch より上（ヒーロー）に戻ったら薄いオーバーレイへ
        if (catchPanel && overlay) {
          ScrollTrigger.create({
            trigger: catchPanel,
            start: "top 80%",
            onLeaveBack: function () {
              gsap.to(overlay, {
                opacity: 0.2,
                duration: 0.35,
                ease: "power1.out",
                overwrite: true,
              });
            },
          });
        }

        // 白セクションが上端に触れる少し前: 固定タイトルを黒文字に
        function setTitleOnWhite(active) {
          document.body.classList.toggle("is-tn-cc-title-on-white", active);
        }

        if (whitePanel) {
          ScrollTrigger.create({
            trigger: whitePanel,
            start: "top 12%",
            onEnter: function () {
              setTitleOnWhite(true);
            },
            onEnterBack: function () {
              setTitleOnWhite(true);
            },
            onLeaveBack: function () {
              setTitleOnWhite(false);
            },
          });

          // 白セクションが CTA に重なったら黒枠・黒文字・黒矢印
          if (ctaEl) {
            ScrollTrigger.create({
              trigger: whitePanel,
              start: function () {
                return "top " + Math.round(ctaEl.getBoundingClientRect().bottom) + "px";
              },
              invalidateOnRefresh: true,
              onEnter: function () {
                document.body.classList.add("is-tn-cc-cta-on-white");
              },
              onEnterBack: function () {
                document.body.classList.add("is-tn-cc-cta-on-white");
              },
              onLeaveBack: function () {
                document.body.classList.remove("is-tn-cc-cta-on-white");
              },
            });
          }

          // footer が CTA に重なったら非表示
          var footer = document.querySelector(".footer");
          if (footer && ctaEl) {
            ScrollTrigger.create({
              trigger: footer,
              start: function () {
                return "top " + Math.round(ctaEl.getBoundingClientRect().bottom) + "px";
              },
              invalidateOnRefresh: true,
              onEnter: function () {
                document.body.classList.add("is-tn-cc-cta-hidden");
              },
              onEnterBack: function () {
                document.body.classList.add("is-tn-cc-cta-hidden");
              },
              onLeaveBack: function () {
                document.body.classList.remove("is-tn-cc-cta-hidden");
              },
            });
          }

          // 白セクションが画面上部に触れたら: 言語切替を黒に
          ScrollTrigger.create({
            trigger: whitePanel,
            start: "top top",
            onEnter: function () {
              document.body.classList.add("is-tn-cc-white");
            },
            onEnterBack: function () {
              document.body.classList.add("is-tn-cc-white");
            },
            onLeaveBack: function () {
              document.body.classList.remove("is-tn-cc-white");
            },
          });
        }

        syncTitleToVideo();

        return function () {
          if (title) title.style.removeProperty("--tn-cc-title-top");
        };
      }
    );

    ScrollTrigger.refresh();

    if (document.fonts && document.fonts.ready && !root._tnCcFontRefresh) {
      root._tnCcFontRefresh = true;
      document.fonts.ready.then(function () {
        ScrollTrigger.refresh();
      });
    }

    // スクロール設定後に入場アニメ（初期 scale / 位置を壊さない）
    playTnCcIntro(root, wrap, title);
  }

  /* sticky ヘッダーのスクロール切替を止め、ロゴのカクつきを防ぐ */
  function stabilizeTnCcHeader() {
    var stickyHeader = document.querySelector("sticky-header");
    var header = document.querySelector(".shopify-section-header");
    if (!header) return;

    if (stickyHeader) {
      if (stickyHeader.onScrollHandler) {
        window.removeEventListener("scroll", stickyHeader.onScrollHandler, false);
      }
      // 後から付いた listener / 再実行も無効化
      stickyHeader.onScroll = function () {};
      stickyHeader.onScrollHandler = function () {};
    }

    header.classList.remove(
      "shopify-section-header-sticky",
      "shopify-section-header-always-sticky",
      "shopify-section-header-hidden",
      "animate"
    );
    header.style.transition = "none";
    header.style.transform = "none";

    if (header.classList.contains("color-background-1")) {
      header.classList.add("color-background-3");
    }
  }

  /* info の下端が画面下に達したら固定。白セクションとフッターが上に重なる */
  function initInfoPin() {
    if (window._tnCcInfoPinBound) return;
    window._tnCcInfoPinBound = true;

    function update() {
      var pin = document.querySelector("[data-tn-cc-info-pin]");
      var info = document.querySelector("[data-tn-cc-info]");
      if (!pin || !info) return;

      var vh = window.innerHeight;
      var rect = pin.getBoundingClientRect();
      var pinned = info.classList.contains("is-pinned");

      if (!pinned && rect.bottom <= vh + 1) {
        var height = pin.offsetHeight;
        pin.style.height = height + "px";
        info.style.height = height + "px";
        info.classList.add("is-pinned");
      } else if (pinned && rect.bottom > vh + 1) {
        info.classList.remove("is-pinned");
        info.style.height = "";
        pin.style.height = "";
      }
    }

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", function () {
      var pin = document.querySelector("[data-tn-cc-info-pin]");
      var info = document.querySelector("[data-tn-cc-info]");
      if (!pin || !info) return;
      info.classList.remove("is-pinned");
      info.style.height = "";
      pin.style.height = "";
      update();
    });
    update();
  }

  function initTnCcPage() {
    stabilizeTnCcHeader();
    initInfoPin();
    // sticky-header の connectedCallback より後にも再適用
    window.setTimeout(stabilizeTnCcHeader, 0);
    window.setTimeout(stabilizeTnCcHeader, 300);

    var root = document.querySelector("[data-tn-cc]");
    // テーマエディタの section:load ではイントロをやり直す
    if (root && root.classList.contains("is-intro-done")) {
      root._tnCcIntroPlayed = false;
      root.classList.add("is-intro-pending");
      root.classList.remove("is-intro-done");
    }

    initTnCcVideo();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTnCcPage);
  } else {
    initTnCcPage();
  }

  window.addEventListener("load", stabilizeTnCcHeader);
  document.addEventListener("shopify:section:load", initTnCcPage);
})();
